import React from 'react';
import { Box, Grid, Container } from '@mui/material';
import Footer from './Footer';
import LoginForm from '../LoginForm';
import { LoginFormProps } from '../../../shared/types';
import { useThemeMode } from '../../../../../contexts/ThemeProvider';
import AdvancedVisualElements from './FloatingIcons';
import ThemeToggle from '../../../../../components/ThemeToggle';

const RightSection = ({ authLogic, config }: LoginFormProps) => {
  const { mode } = useThemeMode();
  const isDark = mode === 'dark';

  const leftSectionConfig = config?.login?.leftSection || {};
  const footerConfig = config?.login?.footer || {};

  return (
    <Grid item xs={12} md={leftSectionConfig.enabled === false ? 12 : 6}>
      <Box
        sx={{
          height: '100vh',
          display: 'flex',
          flexDirection: 'column',
          backgroundColor: isDark ? '#1a1a1a' : '#ffffff',
          position: 'relative',
          overflow: 'hidden'
        }}
      >
        <ThemeToggle />

        <AdvancedVisualElements primaryColor={config?.theme?.secondary || '#002465'} isDark={isDark} />

        <Box
          sx={{
            flex: 1,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            p: 3,
            position: 'relative',
            zIndex: 1
          }}
        >
          <Container maxWidth="sm">
            <Box
              sx={{
                p: { xs: 2, sm: 3 },
                borderRadius: 2,
                backgroundColor: isDark ? 'rgba(30, 30, 30, 0.95)' : 'rgba(255, 255, 255, 0.95)',
                backdropFilter: 'blur(10px)',
                boxShadow: isDark ? '0 8px 32px rgba(0, 0, 0, 0.3)' : '0 8px 32px rgba(0, 0, 0, 0.1)',
                border: isDark ? '1px solid rgba(255, 255, 255, 0.1)' : '1px solid rgba(255, 255, 255, 0.2)'
              }}
            >
              <LoginForm authLogic={authLogic} config={config} />
              
              <Box
                sx={{
                  mt: 3,
                  pt: 2,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: 1,
                  borderTop: isDark ? '1px solid rgba(255, 255, 255, 0.1)' : '1px solid rgba(0, 0, 0, 0.1)',
                }}
              >
              
                <Box
                  component="img"
                  src="https://cdn.jsdelivr.net/gh/Falco-Peregrinus-Technologies-pvt-Ltd/falco-cdn-assets/assests/poweredby.png"
                  alt="CaseCrumbs"
                  sx={{
                    height: { xs: '26px', sm: '26px' },
                    width: 'auto',
                    objectFit: 'contain'
                  }}
                />
              </Box>
            </Box>
          </Container>
        </Box>

        {footerConfig.enabled !== false && <Footer config={config} />}
      </Box>
    </Grid>
  );
};

export default RightSection;